<template>
  <div class="promo-bar" :style="barStyle">
    <transition name="promo-swap" mode="out-in">
      <span :key="index" class="promo-bar__content">
        <component :is="current.icon" class="promo-bar__icon" aria-hidden="true" />
        <span class="promo-bar__text">{{ current.text }}</span>
      </span>
    </transition>
  </div>
</template>

<script>
import DeliveryIcon from './icons/package-outline.svg?inline'
import UserIcon from './icons/client-outline.svg?inline'
import StarIcon from './icons/star-outline.svg?inline'
import PerfectFitIcon from './icons/perfect-fit-outline.svg?inline'
import HeartIcon from './icons/heart-outline.svg?inline'

const MESSAGES = Object.freeze([
  { icon: StarIcon, text: '10.000+ verifizierte Bewertungen' },
  { icon: PerfectFitIcon, text: '30 Tage PerfectFit-Rundumservice' },
  { icon: UserIcon, text: '500.000+ begeisterte Kunden' },
  { icon: DeliveryIcon, text: 'Kostenloser Versand ab 150 Euro' },
  { icon: HeartIcon, text: 'Lokale Herstellung in unserer Manufaktur' }
])

export default {
  name: 'PromoBarF',

  props: {
    // Message change interval
    interval: { type: Number, default: 3000 },
    // Wave animation duration
    sweepDuration: { type: Number, default: 3000 }
  },

  data () {
    return {
      messages: MESSAGES,
      index: 0,
      timer: null
    }
  },

  computed: {
    current () {
      return this.messages[this.index]
    },
    barStyle () {
      return { '--promo-duration': `${this.sweepDuration}ms` }
    }
  },

  mounted () {
    if (this.messages.length > 1) {
      this.timer = setInterval(this.next, this.interval)
    }
  },

  beforeDestroy () {
    clearInterval(this.timer)
  },

  methods: {
    next () {
      this.index = (this.index + 1) % this.messages.length
    }
  }
}
</script>

<style>
header > div > div.menu-container {
  padding-top: 1.5rem;
}
</style>

<style scoped>
.promo-bar {
  --promo-color-a: rgba(210, 3, 17, 0.1);
  --promo-sweep-base: rgba(210, 3, 17, 0.03);
  --promo-text: #d20311;
  --promo-height: 36px;
  --promo-font-size: 13px;
  --promo-font-weight: 600;
  --promo-duration: 3s;

  position: relative;
  isolation: isolate;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--promo-height);
  overflow: hidden;
  background: var(--promo-sweep-base);
  color: var(--promo-text);
  font-size: var(--promo-font-size);
  font-weight: var(--promo-font-weight);
  white-space: nowrap;
}

.promo-bar::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(
    to right,
    transparent,
    var(--promo-color-a) 50%,
    transparent
  );
  transform: translateX(-100%);
  animation: promo-sweep var(--promo-duration) ease-in-out infinite;
  pointer-events: none;
}

@keyframes promo-sweep {
  from { transform: translateX(-100%); }
  to { transform: translateX(100%); }
}

.promo-bar__content {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 100%;
}

.promo-bar__icon {
  position: relative;
  top: -1px;
  display: block;
  flex: none;
  width: 16px;
  height: 16px;
}

.promo-bar__icon:not([fill="none"]) {
  fill: currentColor;
}

.promo-bar__icon ::v-deep path:not([fill="none"]),
.promo-bar__icon ::v-deep circle:not([fill="none"]),
.promo-bar__icon ::v-deep rect:not([fill="none"]),
.promo-bar__icon ::v-deep ellipse:not([fill="none"]),
.promo-bar__icon ::v-deep polygon:not([fill="none"]) {
  fill: currentColor !important;
}

.promo-bar__icon[stroke]:not([stroke="none"]),
.promo-bar__icon ::v-deep [stroke]:not([stroke="none"]) {
  stroke: currentColor;
}

.promo-bar__text {
  display: block;
  line-height: 1;
  text-box: trim-both cap alphabetic;
}

.promo-swap-enter-active,
.promo-swap-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.promo-swap-enter {
  opacity: 0;
  transform: translateY(6px);
}

.promo-swap-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

@media (prefers-reduced-motion: reduce) {
  .promo-bar::before {
    display: none;
  }

  .promo-swap-enter-active,
  .promo-swap-leave-active {
    transition: none;
  }
}
</style>
